import jQuery from 'jquery';

export function initialize() {
	var el = document.createElement('input');

	var test = 'placeholder' in el;

	jQuery.support.placeholder = test;
}

function clearValue(){
	var $this = $(this);

	var value = $this.val();
	var placeholderText = $this.attr('placeholder');

	if(value === placeholderText) {
		$this.val('');
	}
}

function fillValue(){
	var $this = $(this);

	var value = $this.val();
	var placeholderText = $this.attr('placeholder');

	// if the value is empty, put the placeholder value in it's place
	if(!value || value === '') {
		$this.val(placeholderText);
	}
}

export function polyfill() {
	if(jQuery.support.placeholder == null){
		returnVal.initialize();
	}

	if(!jQuery.support.placeholder) {
		let $inputs = $('[placeholder]');

		$inputs.each(function(){
			var $this = $(this),
				$form = $this.closest('form').first();

			$form.on('submit', function(e){

				if($form.is($(this))){
					$('[placeholder]', $(this)).each(clearValue);
				}
			});

		});

		$inputs.each(fillValue);

		//On focus, if the value is the same as the placeholder, empty the value
		$inputs.focus(clearValue)
			//On blur, if the value is empty, replace with placeholder text
			.blur(fillValue);
	}
}

var returnVal = {
	initialize: initialize,
	polyfill: polyfill
};

export default returnVal;
